import { createGlobalStyle } from 'styled-components';

export const InjectStickers = createGlobalStyle`
  :root[data-theme='dark'] {
    --sticker-award: url(/assets-react/stickers/v2/award-dark.svg);
    --sticker-best: url(/assets-react/stickers/v2/best-dark.svg);
    --sticker-like: url(/assets-react/stickers/v2/like-dark.svg);
  }

  :root[data-theme='light'] {
    --sticker-award: url(/assets-react/stickers/v2/award-light.svg);
    --sticker-best: url(/assets-react/stickers/v2/best-light.svg);
    --sticker-like: url(/assets-react/stickers/v2/like-light.svg);
  }
`;
